import { AdminOptionsState } from "../store/AdminOptions/type";
import { DefaultTimeSpan, DefaultInactivityDelay, DefaultLatenessDelay, DefaultMaximumTimeGapBetweenAppointments, DefaultCheckInDelay } from "../store/AdminOptions/reducer";
import { LanguageCodes } from "../constants/languages";

class LocalStorageManager {
    public readonly ADMIN_OPTIONS = "adminOptions";
    public getAdminOptions(): AdminOptionsState {
        if (localStorage.getItem(this.ADMIN_OPTIONS)) {
            const data = JSON.parse(localStorage.getItem(this.ADMIN_OPTIONS));
            if (data !== null && data !== undefined) {
                return {
                    ableToSeeAndModifyExistingPatientData: data["ableToSeeAndModifyExistingPatientData"] || false,
                    ableToSeeAndModifyExistingPreferredPharmacy: data["ableToSeeAndModifyExistingPreferredPharmacy"] || false,
                    regionCodeConfirmationRequired: data["regionCodeConfirmationRequired"] || false,
                    showProfilePictureDuringConfirmation: data["showProfilePictureDuringConfirmation"] || false,
                    healthCardExpirationRedirectToReception: data["healthCardExpirationRedirectToReception"] || false,
                    patientAbleToBookNewAppointments: data["patientAbleToBookNewAppointments"] || false,
                    useableLanguages: new Set<LanguageCodes>(data["useableLanguages"]) || new Set<LanguageCodes>(),
                    defaultLanguage: data["defaultLanguage"] || LanguageCodes.French,
                    sessionTimeSpan: data["sessionTimeSpan"] || DefaultTimeSpan,
                    inactivityDelay: data["inactivityDelay"] || DefaultInactivityDelay,
                    latenessDelay: data["latenessDelay"] || DefaultLatenessDelay,
                    maximumTimeGapBetweenAppointments: data["maximumTimeGapBetweenAppointments"] || DefaultMaximumTimeGapBetweenAppointments,
                    checkInDelay: data["checkInDelay"] || DefaultCheckInDelay,
                    siteId: data["siteId"] || null,
                    multiSiteIds: Array.isArray(data["multiSiteIds"]) ? new Set<string>(data["multiSiteIds"]) : new Set<string>()
                };
            }
        }
        return null;
    }

    public setAdminOptions(data: AdminOptionsState) {
        const toLocalStorage = Object.assign({}, data, {
            useableLanguages: Array.from(data.useableLanguages.values()),
            multiSiteIds: Array.from(data.multiSiteIds.values())
        });

        localStorage.setItem(this.ADMIN_OPTIONS, JSON.stringify(toLocalStorage));
    }
}

export default new LocalStorageManager();



// WEBPACK FOOTER //
// ./src/services/LocalStorageManager.ts